import keycloakService from '../../keycloak_service';

import { set_active_request } from '../../components/assays/V2Assays/conversions';
import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const changeAssayStatus = (assayId, workspaceId, status, isAssaysV2Enabled) => {
  let body = JSON.stringify({ id: assayId, active: status })
  let path = 'v1/api/assays/set_active'

  /**
   * @deprecated Assays V1 Logic
   */
  if (isAssaysV2Enabled) {
    body = JSON.stringify(set_active_request(assayId, status))
    path = 'v2/api/assays/set_active'
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi(path, fetchOptions)
}

export default changeAssayStatus;
